import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const articleLinks = [
  { name: 'Shopping Guide', path: '/guides/best-pandabuy-spreadsheet-guide' },
  { name: 'Sneakers Guide', path: '/guides/pandabuy-sheet-sneakers-guide' },
  { name: 'Budget Finds', path: '/guides/pandabuy-sheet-budget-finds' },
  { name: 'Streetwear Picks', path: '/guides/pandabuy-sheet-streetwear-guide' },
  { name: 'Accessories', path: '/guides/pandabuy-sheet-accessories-guide' },
  { name: 'Quality Tips', path: '/guides/pandabuy-sheet-quality-tips' },
  { name: 'vs Competitors', path: '/guides/pandabuy-sheet-vs-competitors' },
  { name: 'Beginner Tips', path: '/guides/pandabuy-sheet-beginner-tips' },
  { name: 'Trending 2026', path: '/guides/pandabuy-sheet-trending-products' },
  { name: 'Safety Guide', path: '/guides/pandabuy-sheet-safety-guide' },
];

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [guidesOpen, setGuidesOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileMenuOpen]);

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
        <div className="w-full px-4 md:px-10">
          <div className="flex items-center justify-between h-16 md:h-18">
            <Link
              to="/"
              className="text-lg md:text-2xl font-heading font-bold italic text-foreground-950 whitespace-nowrap"
            >
              Pandabuy<span className="text-primary-500 not-italic">.homes</span>
            </Link>

            <div className="hidden md:flex items-center gap-6">
              <Link
                to="/"
                className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                Home
              </Link>

              <div className="relative">
                <button
                  onClick={() => { setGuidesOpen(!guidesOpen); setDropdownOpen(false); }}
                  className="text-sm font-semibold text-foreground-900 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1"
                >
                  Shopping Guide
                  <span className={`w-3 h-3 flex items-center justify-center transition-transform duration-200 ${guidesOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-xs"></i>
                  </span>
                </button>
                {guidesOpen && (
                  <>
                    <div className="fixed inset-0 z-10" onClick={() => setGuidesOpen(false)} />
                    <div className="absolute top-full mt-2 left-0 w-56 bg-background-50 border border-background-200/70 rounded-xl py-2 z-20 shadow-lg">
                      {articleLinks.map((link) => (
                        <Link
                          key={link.path}
                          to={link.path}
                          onClick={() => setGuidesOpen(false)}
                          className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 whitespace-nowrap"
                        >
                          {link.name}
                        </Link>
                      ))}
                    </div>
                  </>
                )}
              </div>

              <div className="relative">
                <button
                  onClick={() => { setDropdownOpen(!dropdownOpen); setGuidesOpen(false); }}
                  className="flex items-center gap-2 px-4 py-2 bg-foreground-950 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  Categories
                  <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line text-sm"></i>
                  </span>
                </button>
                {dropdownOpen && (
                  <>
                    <div className="fixed inset-0 z-10" onClick={() => setDropdownOpen(false)} />
                    <div className="absolute top-full mt-2 right-0 w-64 bg-background-50 border border-background-200/70 rounded-xl py-2 z-20 max-h-80 overflow-y-auto shadow-lg">
                      {categories.map((cat) => (
                        <a
                          key={cat.name}
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          onClick={() => setDropdownOpen(false)}
                          className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors duration-150 whitespace-nowrap"
                        >
                          <span className="w-5 h-5 flex items-center justify-center">
                            <i className={`${cat.icon} text-base`}></i>
                          </span>
                          {cat.name}
                        </a>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="hidden md:flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Pandabuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-5 py-2 border border-foreground-300 rounded-full text-sm font-medium text-foreground-800 hover:bg-foreground-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-background-100 active:bg-background-200 transition-colors cursor-pointer"
              aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {mobileMenuOpen ? (
                <i className="ri-close-line text-xl text-foreground-950"></i>
              ) : (
                <i className="ri-menu-line text-xl text-foreground-950"></i>
              )}
            </button>
          </div>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 z-[60] bg-background-50 overflow-y-auto">
          <div className="px-4 py-5 flex flex-col gap-5">
            <div className="flex gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={closeMobileMenu}
                className="flex-1 px-4 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold text-center hover:bg-primary-600 active:bg-primary-700 transition-colors whitespace-nowrap"
              >
                Pandabuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={closeMobileMenu}
                className="flex-1 px-4 py-3 border border-foreground-300 rounded-full text-sm font-medium text-foreground-800 text-center hover:bg-foreground-100 active:bg-foreground-200 transition-colors whitespace-nowrap"
              >
                Buy It Now
              </a>
            </div>

            <Link
              to="/"
              onClick={closeMobileMenu}
              className="flex items-center gap-3 py-3 text-base font-semibold text-foreground-900 active:text-primary-500 transition-colors"
            >
              <span className="w-6 h-6 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                <i className="ri-home-4-line text-sm text-primary-500"></i>
              </span>
              Home
            </Link>

            <div className="pt-2 border-t border-background-200/70">
              <div className="flex items-center justify-between mb-3">
                <p className="text-xs font-bold text-foreground-500 uppercase tracking-wider">
                  Shopping Guides
                </p>
                <span className="text-[10px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                  10 articles
                </span>
              </div>
              <div className="grid grid-cols-2 gap-2">
                {articleLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={closeMobileMenu}
                    className="px-3 py-2.5 bg-background-100 rounded-xl text-xs font-medium text-foreground-700 hover:bg-accent-100 hover:text-accent-800 active:bg-accent-200 transition-colors text-center whitespace-nowrap"
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </div>

            <div className="pt-2 border-t border-background-200/70">
              <div className="flex items-center justify-between mb-3">
                <p className="text-xs font-bold text-foreground-500 uppercase tracking-wider">
                  Product Categories
                </p>
                <span className="text-[10px] text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                  14 categories
                </span>
              </div>
              <div className="grid grid-cols-2 gap-2">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={closeMobileMenu}
                    className="flex items-center gap-2 px-3 py-2.5 bg-background-100 rounded-xl text-xs font-medium text-foreground-700 hover:bg-accent-100 hover:text-accent-800 active:bg-accent-200 transition-colors whitespace-nowrap"
                  >
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 rounded bg-accent-100">
                      <i className={`${cat.icon} text-[10px] text-accent-600`}></i>
                    </span>
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div className="pt-4 pb-8 border-t border-background-200/70">
              <p className="text-[10px] text-foreground-400 text-center">
                &copy; 2026 Pandabuy.homes — Curated Product Hub
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}